const environment = process.env.NODE_ENV;

// local
export const host = (environment == 'development') ? 'http://localhost:8080' : '';

// QA
//export const host = (environment == 'development') ? 'https://efp.nyser.qa.intcx.net' : '';

